@if(isTimelineEmpty){
<div class="nomoods-container">
    <div class="nomoods">
        <p>{{'no_moods_message' | translate}}</p>
        <img src="/assets/images/nocomment.svg">
    </div>
</div>
}